import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=7625d4f6&scoped=true&"
import script from "./Documents.vue?vue&type=script&lang=js&"
export * from "./Documents.vue?vue&type=script&lang=js&"
import style0 from "./Documents.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Documents.vue?vue&type=style&index=1&id=7625d4f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7625d4f6",
  null
  
)

export default component.exports